import { BaseGameData } from '../types/GameData.ts';
import { GameDataWithDictionary } from '../types/GameConfig.ts';

export type LegacyWordPair = [
  string, // startWord
  string, // endWord
  number, // optimalPathLength
  Array<string>, // optimalPath
  { type: string, version: number, patch: number }?, // dictionary (optional)
  string?, // emoji (optional)
  string?, // message (optional)
  string?  // backgroundColor (optional)
];

type WordPairSpecial = {
  emoji?: string,
  message?: string,
  backgroundColor?: string,
};

export type WordPair = GameDataWithDictionary & {
  startWord: string;
  endWord: string;
  optimalPathLength: number;
  optimalPath: Array<string>;
} & WordPairSpecial;

export class WeaverGameData extends BaseGameData<WordPair> {
  getOptimalPathLength(gameNumber: number): number {
    const wordPair = this.getDailyGame(gameNumber);
    return wordPair?.optimalPathLength ?? 0;
  }

  getSpecialData(gameNumber: number): WordPairSpecial {
    const wordPair = this.getDailyGame(gameNumber);
    if (!wordPair) {
      return {};
    }
    const { emoji, message, backgroundColor } = wordPair;
    return { emoji, message, backgroundColor };
  }

  getSpecialEmoji(gameNumber: number): string | null {
    const wordPair = this.getDailyGame(gameNumber);
    return wordPair?.emoji ?? null;
  }

  getSpecialMessageData(gameNumber: number): [string | null, string | null] {
    const wordPair = this.getDailyGame(gameNumber);
    if (!wordPair) {
      return [null, null];
    }
    return [
      wordPair.message || null,
      wordPair.backgroundColor || null
    ];
  }
} 